/**
 * @generated SignedSource<<1e58d607e8989b3be87557d0b2d40fdf>>
 * @relayHash 147cfb56caf40781fcb1a06a43b2650f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e2044cc1d4d9be7cb653dcf45f27af1fd0edc7eddcd49f51b760e768099e55e0

import type { ConcreteRequest } from 'relay-runtime';
export type useCreateOfflineVersionInsertVersionMutation$variables = {
  adfContent: string;
  cloudId: string;
  contentId: string;
  versionComment: string;
};
export type useCreateOfflineVersionInsertVersionMutation$data = {
  readonly confluence_insertOfflineVersion: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
    readonly versionNumber: number | null;
  } | null;
};
export type useCreateOfflineVersionInsertVersionMutation = {
  response: useCreateOfflineVersionInsertVersionMutation$data;
  variables: useCreateOfflineVersionInsertVersionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "adfContent"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionComment"
},
v4 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "adfContent",
            "variableName": "adfContent"
          },
          {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
          },
          {
            "kind": "Variable",
            "name": "versionComment",
            "variableName": "versionComment"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ConfluenceInsertOfflineVersionPayload",
    "kind": "LinkedField",
    "name": "confluence_insertOfflineVersion",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "versionNumber"
      },
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCreateOfflineVersionInsertVersionMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCreateOfflineVersionInsertVersionMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "147cfb56caf40781fcb1a06a43b2650f",
    "id": "e2044cc1d4d9be7cb653dcf45f27af1fd0edc7eddcd49f51b760e768099e55e0",
    "metadata": {},
    "name": "useCreateOfflineVersionInsertVersionMutation",
    "operationKind": "mutation",
    "text": "mutation useCreateOfflineVersionInsertVersionMutation($cloudId:ID!,$contentId:ID!,$adfContent:String!,$versionComment:String!){confluence_insertOfflineVersion(cloudId:$cloudId,input:{contentId:$contentId,adfContent:$adfContent,versionComment:$versionComment}){versionNumber,success,errors{message}}}"
  }
};
})();

(node as any).hash = "116628d327fa315abf5c5c89f4dd52a8";

export default node;
